import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AsignLawyerDialogComponent } from 'src/app/dialogs/asign-lawyer-dialog/asign-lawyer-dialog.component';
import { AssignedLawyerDialogComponent } from 'src/app/dialogs/assigned-lawyer-dialog/assigned-lawyer-dialog.component';
import { ReturnRequirementDialogComponent } from 'src/app/dialogs/return-requirement-dialog/return-requirement-dialog.component';
import { ResponseObjectAPI } from '@models/responseObjectAPI';
import { RequirementService } from '@services/requirement.service';
import { Utils } from 'src/app/util/util';

@Component({
    selector: 'app-header-req-document',
    templateUrl: './header-req-document.component.html',
    styleUrls: ['./header-req-document.component.scss'],
    standalone: false
})
export class HeaderReqDocumentComponent implements OnInit {

  @Input() requirement;
  @Input() header: string;
  @Output() sendAction = new EventEmitter<boolean>();

  constructor(
    private modalService: NgbModal,
    public requirementService: RequirementService,
    public activatedRoute: ActivatedRoute,
    public util: Utils
  ) { }

  ngOnInit() {

  }

  assign() {
    const modalRef = this.modalService.open(AsignLawyerDialogComponent, { 
      windowClass:'animated slideInUp',
      centered: true, 
      backdrop: 'static',
      keyboard: false, 
      size: 'sm', 
    });
    modalRef.componentInstance.requirementId = this.requirement.id;
    modalRef.componentInstance.users = this.requirement.collaborators;
    modalRef.componentInstance.userAsigned.subscribe(userAsigned => {
			this.showConfirmation(userAsigned, 'Requerimiento Asignado', 'Asignado a');
			this.sendAction.emit(true);
    });
  }

  take() {
    const body = {
      requirementid: this.requirement.id
    };
    this.requirementService.takeRequirement(body).subscribe((resp: ResponseObjectAPI) => {
			this.showConfirmation({ name: this.requirement.creator }, 'Has tomado el requerimiento', 'Solicitante');
			this.sendAction.emit(true);
    });
  }

  return() {
    const modalRef = this.modalService.open(ReturnRequirementDialogComponent, { centered: true, backdrop: 'static',
    keyboard: false });
    modalRef.componentInstance.requirementId = this.requirement.id;
    modalRef.componentInstance.returned.subscribe(returned => {
			this.showConfirmation({ name: this.requirement.creator }, 'Has devuelto el requerimiento', 'Solicitante');
			this.sendAction.emit(true);
    });
  }

  showConfirmation(userAsigned, title, assignText) {
    const modalRef = this.modalService.open(AssignedLawyerDialogComponent, { centered: true, size: 'sm', windowClass: 'dialog-primary' });
    modalRef.componentInstance.userName = userAsigned.name;
    modalRef.componentInstance.sla = this.util.getRemaining(this.requirement.remaining);
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.assignText = assignText;
  }

}
